"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _constants = require("../../constants");
var _buttonStateMixin = require("../buttonStateMixin");
var _disabledMixin = require("../disabledMixin");
var _focusMixin = require("../focusMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _sizeMixin = require("../sizeMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var fluidCSS = function fluidCSS(mediaProps) {
  return (0, _styledComponents.css)(["width:", ";"], mediaProps.fluid ? '100%' : 'auto');
};
/** @class ButtonMixin */
/** @method */
var ButtonMixin = function ButtonMixin(props) {
  var size = props.size,
    buttonType = props.buttonType,
    disabled = props.disabled;
  return (0, _styledToken.default)({
    borderRadius: 'Button.borderRadius',
    borderWidth: 'Button.borderWidth',
    fontType: "Button.fontType" + (size === _constants.BUTTON_SIZES.sm ? 'Small' : ''),
    horizontalPadding: 'Button.horizontalPadding',
    targetSize: 'Button.targetSize',
    margin: 'Button.margin',
    transitionDuration: 'Button.transitionDuration',
    transitionProperty: 'Button.transitionProperty',
    transitionTimingFunction: 'Button.transitionTimingFunction',
    pressedBorderWidth: 'Button.pressed.borderWidth',
    pressedHorizontalPadding: 'Button.pressed.horizontalPadding'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      targetSize = _ref.targetSize,
      _ref$transitionDurati = _ref.transitionDuration,
      transitionDuration = _ref$transitionDurati === void 0 ? 0.2 : _ref$transitionDurati,
      _ref$transitionProper = _ref.transitionProperty,
      transitionProperty = _ref$transitionProper === void 0 ? 'background-color, border-color, color' : _ref$transitionProper,
      _ref$transitionTiming = _ref.transitionTimingFunction,
      transitionTimingFunction = _ref$transitionTiming === void 0 ? 'ease' : _ref$transitionTiming,
      _ref$pressedBorderWid = _ref.pressedBorderWidth,
      pressedBorderWidth = _ref$pressedBorderWid === void 0 ? 2 : _ref$pressedBorderWid,
      pressedHorizontalPadding = _ref.pressedHorizontalPadding;
    return (0, _styledComponents.css)(["cursor:pointer;text-decoration:none;text-align:center;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;border:", "px solid;border-radius:", "px;user-select:none;padding-left:", "px;padding-right:", "px;margin:", "px;-webkit-appearance:none;transition-property:", ";transition-duration:", "s;transition-timing-function:", ";pointer-events:", ";", " ", " &,&:focus,&:visited,&:disabled{", "}", " &[aria-pressed=\"true\"][aria-pressed=\"true\"]{", " ", "}&:active:not(:disabled){", "}position:relative;&:after{content:'';position:absolute;left:0;height:", "px;min-width:", "px;width:100%;top:50%;margin-top:-", "px;}", " ", " ", " ", ""], borderWidth, borderRadius, horizontalPadding, horizontalPadding, margin, transitionProperty, transitionDuration, transitionTimingFunction, disabled ? 'none' : 'auto', (0, _focusMixin.focusMixin)(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('fluid', fluidCSS)(props), (0, _buttonStateMixin.buttonStateMixin)()(props), (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)((0, _buttonStateMixin.buttonStateMixin)('Hover')(props)), (0, _buttonStateMixin.buttonStateMixin)('Pressed')(props), buttonType === _constants.BUTTON_TYPES.tertiary ? "\n          border-width: " + pressedBorderWidth + "px;\n          padding-left: " + (pressedHorizontalPadding ? pressedHorizontalPadding + "px" : horizontalPadding - 1 + "px") + ";\n          padding-right: " + (pressedHorizontalPadding ? pressedHorizontalPadding + "px" : horizontalPadding - 1 + "px") + ";\n          " + (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 4
    })(props) + "\n        " : null, (0, _buttonStateMixin.buttonStateMixin)('Active')(props), targetSize, targetSize, targetSize / 2, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), (0, _disabledMixin.disabledMixin)(props), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2
    })(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.ButtonMixin = ButtonMixin;